export const environment = {
  production: false,
  baseUrl:'https://dev-app.freightfox.ai/',
  s3baseUrl: 'https://dev-doraemon.freightfox.ai/',
  conciergeUrl: 'https://dev-concierge.freightfox.ai',
  rbacUrl: 'https://dev-rbac.freightfox.ai',
  hermesUrl: 'https://dev-hermes.freightfox.ai',
  doremonDocKey: 'FYZCG7c6AyJsAFR5+vQLizg9/PuQAV6QMUTyxOqdpEc=',
};
